import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "container px-0" }
const _hoisted_4 = { class: "row fv-row mb-2 mt-2" }
const _hoisted_5 = { class: "col-sm-6 col-md-8 mb-1 d-flex justify-content-start" }
const _hoisted_6 = {
  key: 0,
  style: {},
  id: "myDropdownDownload",
  class: "dropdown-content"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-md btn-primary me-3",
  id: "btnUpload",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_upload_multiple"
}, " Upload Foto ", -1)
const _hoisted_9 = { class: "container px-0" }
const _hoisted_10 = { class: "row fv-row mb-2 mt-2" }
const _hoisted_11 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_12 = { class: "d-flex align-items-center position-relative" }
const _hoisted_13 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_14 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_15 = { class: "d-flex align-items-center position-relative" }
const _hoisted_16 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_17 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_18 = { class: "d-flex align-items-center position-relative" }
const _hoisted_19 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_20 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_21 = { class: "d-flex align-items-center position-relative" }
const _hoisted_22 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_23 = { class: "d-flex align-items-center position-relative" }
const _hoisted_24 = { class: "card-body py-3" }
const _hoisted_25 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_26 = {
  class: "row mb-5",
  style: {"margin-right":"5px","padding-top":"10px","background-color":"aliceblue","border-radius":"15px 15px 15px 15px"}
}
const _hoisted_27 = {
  class: "col-lg-12 fv-row",
  style: {"text-align":"center"}
}
const _hoisted_28 = {
  class: "card-title align-items-center flex-column",
  style: {"font-weight":"700","font-size":"15px"}
}
const _hoisted_29 = { class: "col-lg-3 fv-row" }
const _hoisted_30 = { class: "row mb-3" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "col-lg-9 fv-row" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 1 ")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_36 = { class: "col-7" }
const _hoisted_37 = { style: {"font-size":"12px"} }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 2 ")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_41 = { class: "col-7" }
const _hoisted_42 = { style: {"font-size":"12px"} }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " TTL ")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_46 = { class: "col-7" }
const _hoisted_47 = { style: {"font-size":"12px"} }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Kelas ")
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_51 = { class: "col-7" }
const _hoisted_52 = { style: {"font-size":"12px"} }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Detail Kelas ")
], -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_56 = { class: "col-7" }
const _hoisted_57 = { style: {"font-size":"12px"} }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Jenis Kelamin ")
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_61 = { class: "col-7" }
const _hoisted_62 = { style: {"font-size":"12px"} }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Alamat ")
], -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_68 = { class: "col-7" }
const _hoisted_69 = { style: {"font-size":"12px"} }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Tags ")
], -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_73 = { class: "col-7" }
const _hoisted_74 = { style: {"font-size":"12px"} }
const _hoisted_75 = { class: "row" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Note ")
], -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_78 = { class: "col-7" }
const _hoisted_79 = { style: {"font-size":"12px"} }
const _hoisted_80 = { class: "row" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Status Kartu ")
], -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_83 = { class: "col-7" }
const _hoisted_84 = { style: {"font-size":"12px"} }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Verifikasi Sekolah ")
], -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_88 = { class: "col-7" }
const _hoisted_89 = { style: {"font-size":"12px"} }
const _hoisted_90 = { class: "col-lg-12 fv-row" }
const _hoisted_91 = {
  class: "card-footer border-0 d-flex justify-content-end py-6 px-9",
  style: {"padding-right":"5px !important"}
}
const _hoisted_92 = ["onClick"]
const _hoisted_93 = ["onClick"]
const _hoisted_94 = ["onClick"]
const _hoisted_95 = ["onClick"]
const _hoisted_96 = { class: "row mt-5 mb-5" }
const _hoisted_97 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_98 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_99 = ["label", "value"]
const _hoisted_100 = { class: "p-3" }
const _hoisted_101 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_102 = { class: "pagination" }
const _hoisted_103 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_104 = { class: "row mt-5 mb-5" }
const _hoisted_105 = {
  class: "modal",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_upload_excel"
}
const _hoisted_106 = { class: "modal-dialog modal-xl" }
const _hoisted_107 = { class: "modal-content" }
const _hoisted_108 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_109 = {
  key: 0,
  class: "modal-title justify-content-center"
}
const _hoisted_110 = {
  key: 1,
  class: "modal-title"
}
const _hoisted_111 = {
  key: 2,
  class: "modal-title"
}
const _hoisted_112 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_113 = { class: "svg-icon svg-icon-2x" }
const _hoisted_114 = { class: "modal-body row pt-1" }
const _hoisted_115 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Upload Data Excel"),
  /*#__PURE__*/_createElementVNode("span", null, "         "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "( Format dokumen .xlsx )")
], -1)
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fv-help-block" })
], -1)
const _hoisted_118 = {
  key: 1,
  class: "row"
}
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"125px","margin-bottom":"15px","margin-top":"15px"},
    src: "/media/icons/checklist_icon.svg",
    alt: ""
  })
], -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, " Sukses Melakukan Upload Dokumen ", -1)
const _hoisted_121 = [
  _hoisted_119,
  _hoisted_120
]
const _hoisted_122 = {
  key: 2,
  class: "row"
}
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"125px","margin-bottom":"15px","margin-top":"15px"},
    src: "/media/icons/close_icon.svg",
    alt: ""
  })
], -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, " Gagal Melakukan Upload Dokumen ", -1)
const _hoisted_125 = [
  _hoisted_123,
  _hoisted_124
]
const _hoisted_126 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_127 = {
  key: 1,
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}
const _hoisted_128 = {
  key: 4,
  type: "button",
  class: "btn btn-danger",
  style: {"width":"150px"},
  "data-bs-dismiss": "modal"
}
const _hoisted_129 = { class: "row mt-5 mb-5" }
const _hoisted_130 = {
  class: "modal",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_form_add"
}
const _hoisted_131 = { class: "modal-dialog modal-xl" }
const _hoisted_132 = { class: "modal-content" }
const _hoisted_133 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_134 = { class: "modal-title justify-content-center" }
const _hoisted_135 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_136 = { class: "svg-icon svg-icon-2x" }
const _hoisted_137 = { class: "modal-body row" }
const _hoisted_138 = { class: "col-lg-6" }
const _hoisted_139 = { class: "row" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Nama ", -1)
const _hoisted_141 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_142 = { class: "col-12" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Nomor Identitas 1 ", -1)
const _hoisted_144 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_145 = { class: "col-12" }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Nomor Identitas 2 ", -1)
const _hoisted_147 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_148 = { class: "col-12" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Tempat Lahir ", -1)
const _hoisted_150 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_151 = { class: "col-12" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Tanggal Lahir ", -1)
const _hoisted_153 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_154 = { class: "col-12" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Jenis Kelamin ", -1)
const _hoisted_156 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_157 = { class: "col-12" }
const _hoisted_158 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " kelas ", -1)
const _hoisted_159 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_160 = { class: "col-12" }
const _hoisted_161 = { class: "col-lg-6" }
const _hoisted_162 = { class: "row" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Detail Kelas ", -1)
const _hoisted_164 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_165 = { class: "col-12" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Alamat ", -1)
const _hoisted_167 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_168 = { class: "col-12" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Tags ", -1)
const _hoisted_170 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_171 = { class: "col-12" }
const _hoisted_172 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_173 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_174 = { class: "row mt-5 mb-5" }
const _hoisted_175 = {
  class: "modal",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_add_existing"
}
const _hoisted_176 = { class: "modal-dialog" }
const _hoisted_177 = { class: "modal-content" }
const _hoisted_178 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_179 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, "Pilih User", -1)
const _hoisted_180 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_181 = { class: "svg-icon svg-icon-2x" }
const _hoisted_182 = { class: "modal-body row" }
const _hoisted_183 = { class: "col" }
const _hoisted_184 = { class: "table-responsive" }
const _hoisted_185 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_186 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "NIS"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tags")
  ])
], -1)
const _hoisted_187 = { key: 0 }
const _hoisted_188 = { class: "text-left pl-3" }
const _hoisted_189 = { class: "form-checkbox" }
const _hoisted_190 = ["value"]
const _hoisted_191 = /*#__PURE__*/_createElementVNode("i", { class: "form-icon" }, null, -1)
const _hoisted_192 = { class: "text-left" }
const _hoisted_193 = { class: "text-center" }
const _hoisted_194 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, null, -1)
const _hoisted_195 = { key: 1 }
const _hoisted_196 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, " Tidak Ada Data ")
], -1)
const _hoisted_197 = [
  _hoisted_196
]
const _hoisted_198 = { class: "row mt-5 mb-5" }
const _hoisted_199 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_200 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_201 = ["label", "value"]
const _hoisted_202 = { class: "p-3" }
const _hoisted_203 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_204 = { class: "pagination" }
const _hoisted_205 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_206 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_207 = { class: "row mt-5 mb-5" }
const _hoisted_208 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_upload_personal"
}
const _hoisted_209 = { class: "modal-dialog" }
const _hoisted_210 = { class: "modal-content" }
const _hoisted_211 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_212 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, "Upload Foto", -1)
const _hoisted_213 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_214 = { class: "svg-icon svg-icon-2x" }
const _hoisted_215 = { class: "modal-body row" }
const _hoisted_216 = { class: "row" }
const _hoisted_217 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nama ")
], -1)
const _hoisted_218 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_219 = { class: "col-8" }
const _hoisted_220 = { style: {"font-size":"12px"} }
const _hoisted_221 = { class: "row" }
const _hoisted_222 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 1 ")
], -1)
const _hoisted_223 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_224 = { class: "col-8" }
const _hoisted_225 = { style: {"font-size":"12px"} }
const _hoisted_226 = { class: "row" }
const _hoisted_227 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 2")
], -1)
const _hoisted_228 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_229 = { class: "col-8" }
const _hoisted_230 = { style: {"font-size":"12px"} }
const _hoisted_231 = { class: "row" }
const _hoisted_232 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Detail Kelas ")
], -1)
const _hoisted_233 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_234 = { class: "col-8" }
const _hoisted_235 = { style: {"font-size":"12px"} }
const _hoisted_236 = { class: "row mt-3" }
const _hoisted_237 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Upload Foto Siswa"),
  /*#__PURE__*/_createElementVNode("span", null, "         "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "( Format .jpg .jpeg .png )")
], -1)
const _hoisted_238 = { class: "row mt-2" }
const _hoisted_239 = ["src"]
const _hoisted_240 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_241 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_242 = { class: "row mt-5 mb-5" }
const _hoisted_243 = {
  class: "modal fade",
  ref: "uploadModalMultipleRef",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_upload_multiple"
}
const _hoisted_244 = { class: "modal-dialog" }
const _hoisted_245 = { class: "modal-content" }
const _hoisted_246 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_247 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, " Upload Multiple Foto ", -1)
const _hoisted_248 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_249 = { class: "svg-icon svg-icon-2x" }
const _hoisted_250 = { class: "modal-body row pt-1" }
const _hoisted_251 = {
  key: 0,
  class: "row mt-0"
}
const _hoisted_252 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Pilih File Foto")
], -1)
const _hoisted_253 = {
  key: 1,
  class: "row mt-0"
}
const _hoisted_254 = /*#__PURE__*/_createElementVNode("label", {
  style: {"text-align":"left"},
  class: "col-lg-12 col-form-label fw-bold fs-6"
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px"} }, "Hasil Upload File ")
], -1)
const _hoisted_255 = [
  _hoisted_254
]
const _hoisted_256 = {
  key: 2,
  class: "row mt-0"
}
const _hoisted_257 = /*#__PURE__*/_createStaticVNode("<div class=\"col-8\"><label style=\"text-align:left;margin-left:10px;padding:3px;\" class=\"col-lg-12 col-form-label fw-bold fs-6\"><span style=\"font-size:18px;\">Total Upload</span></label></div><div class=\"col-1\"><label style=\"text-align:left;padding:3px;\" class=\"col-lg-12 col-form-label fw-bold fs-6\"><span style=\"font-size:18px;\">:</span></label></div>", 2)
const _hoisted_259 = { class: "col-3" }
const _hoisted_260 = {
  style: {"text-align":"left","padding":"3px"},
  class: "col-lg-12 col-form-label fw-bold fs-6"
}
const _hoisted_261 = { style: {"font-size":"18px","color":"blue"} }
const _hoisted_262 = {
  key: 3,
  class: "row mt-0"
}
const _hoisted_263 = /*#__PURE__*/_createStaticVNode("<div class=\"col-8\"><label style=\"text-align:left;margin-left:10px;padding:3px;\" class=\"col-lg-12 col-form-label fw-bold fs-6\"><span style=\"font-size:18px;\">Berhasil</span></label></div><div class=\"col-1\"><label style=\"text-align:left;padding:3px;\" class=\"col-lg-12 col-form-label fw-bold fs-6\"><span style=\"font-size:18px;\">:</span></label></div>", 2)
const _hoisted_265 = { class: "col-3" }
const _hoisted_266 = {
  style: {"text-align":"left","padding":"3px"},
  class: "col-lg-12 col-form-label fw-bold fs-6"
}
const _hoisted_267 = { style: {"font-size":"18px","color":"green"} }
const _hoisted_268 = {
  key: 4,
  class: "row mt-0"
}
const _hoisted_269 = /*#__PURE__*/_createStaticVNode("<div class=\"col-8\"><label style=\"text-align:left;margin-left:10px;padding:3px;\" class=\"col-lg-12 col-form-label fw-bold fs-6\"><span style=\"font-size:18px;\">Gagal</span></label></div><div class=\"col-1\"><label style=\"text-align:left;padding:3px;\" class=\"col-lg-12 col-form-label fw-bold fs-6\"><span style=\"font-size:18px;\">:</span></label></div>", 2)
const _hoisted_271 = { class: "col-3" }
const _hoisted_272 = {
  style: {"text-align":"left","padding":"3px"},
  class: "col-lg-12 col-form-label fw-bold fs-6"
}
const _hoisted_273 = { style: {"font-size":"18px","color":"red"} }
const _hoisted_274 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"container px-2 mt-3 mb-3\"><hr style=\"width:100%;\" size=\"5\" color=\"black\"></div></div><div class=\"row mb-3 mx-2\" style=\"font-size:18px;\">Keterangan</div><div class=\"row\"><div class=\"col-12 mx-2\"><label style=\"font-size:13px;\"> - Upload foto bisa lebih dari satu file </label><label style=\"font-size:13px;\"> - Nama Foto harus berupa NIS siswa yang ada di PSP </label><label style=\"font-size:13px;margin-left:15px;\"> Contoh : <span style=\"color:blue;\">202204</span>.jpg </label><br><label style=\"font-size:13px;\"> - Format file foto berupa .jpg, .jpeg, .png, </label></div></div>", 3)
const _hoisted_277 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_278 = {
  key: 1,
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_279 = {
  key: 2,
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}
const _hoisted_280 = { class: "row mt-5 mb-5" }
const _hoisted_281 = {
  class: "modal fade",
  tabindex: "-1",
  id: "modal-confirm"
}
const _hoisted_282 = { class: "modal-dialog" }
const _hoisted_283 = { class: "modal-content" }
const _hoisted_284 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_285 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, "Data Cetak", -1)
const _hoisted_286 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_287 = { class: "svg-icon svg-icon-2x" }
const _hoisted_288 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body row pt-1" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "row",
    style: {"font-size":"16px","text-align":"center","margin-top":"15px"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-7" }, "Konfirmasi data yang akan dicetak?")
  ])
], -1)
const _hoisted_289 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_290 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_291 = { class: "row mt-5 mb-5" }
const _hoisted_292 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_verifikasi_multiple"
}
const _hoisted_293 = { class: "modal-dialog" }
const _hoisted_294 = { class: "modal-content" }
const _hoisted_295 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_296 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, " Verifikasi Semua Data ", -1)
const _hoisted_297 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_298 = { class: "svg-icon svg-icon-2x" }
const _hoisted_299 = { class: "modal-body row pt-1" }
const _hoisted_300 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"font-size":"18px","text-align":"center","margin-top":"15px","font-weight":"800"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, "Informasi Kelengkapan foto")
], -1)
const _hoisted_301 = {
  class: "row",
  style: {"text-align":"center","margin-top":"15px"}
}
const _hoisted_302 = { class: "col-12" }
const _hoisted_303 = { style: {"font-size":"16px","font-weight":"700"} }
const _hoisted_304 = /*#__PURE__*/_createTextVNode(" Data dengan foto : ")
const _hoisted_305 = { style: {"color":"blue"} }
const _hoisted_306 = { class: "col-12" }
const _hoisted_307 = { style: {"font-size":"16px","font-weight":"700"} }
const _hoisted_308 = /*#__PURE__*/_createTextVNode(" Data tanpa foto : ")
const _hoisted_309 = { style: {"color":"red"} }
const _hoisted_310 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"font-size":"16px","text-align":"center","margin-top":"15px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-7" }, " Apakah anda yakin akan melakukan semua verifikasi data kartu ? ")
], -1)
const _hoisted_311 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_312 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "btn btn-md btn-success me-3 show menu-dropdown",
                id: "btnHistory",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDropdown()))
              }, " Tambah Data "),
              (_ctx.showAddDropdownBtn == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("a", {
                      class: "btn",
                      style: {"text-align":"left"},
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadModalChange()))
                    }, "Upload File Excel"),
                    _createElementVNode("a", {
                      class: "btn",
                      style: {"text-align":"left"},
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addUserModalChange()))
                    }, "Tambah User"),
                    _createElementVNode("a", {
                      class: "btn",
                      style: {"text-align":"left"},
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.chooseUserModalChange()))
                    }, "Pilih User")
                  ]))
                : _createCommentVNode("", true),
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("button", {
                class: "btn btn-md me-3",
                id: "btnDownload",
                style: {"background-color":"#8950fc","color":"#fff"},
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadFunction()))
              }, " Download "),
              _createElementVNode("button", {
                class: "btn btn-sm btn-blue me-3",
                style: {"background-color":"darkblue","color":"white"},
                id: "btnBayar",
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.verifikasiMultiple && _ctx.verifikasiMultiple(...args)))
              }, " Verifikasi Semua ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control ps-15",
                  placeholder: "Cari Nama",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.nama) = $event)),
                  onKeyup: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
                }, null, 544), [
                  [_vModelText, _ctx.nama]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control ps-15",
                  placeholder: "Cari NIS",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.nis) = $event)),
                  onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
                }, null, 544), [
                  [_vModelText, _ctx.nis]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control ps-15",
                  placeholder: "Cari Tag",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tag) = $event)),
                  onKeyup: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
                }, null, 544), [
                  [_vModelText, _ctx.tag]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_Multiselect, {
                  class: "mx-1",
                  modelValue: _ctx.isPhoto,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isPhoto) = $event)),
                  placeholder: "Pilih Status Foto",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listDenganFoto,
                  searchable: true,
                  label: "name",
                  "track-by": "name",
                  "value-prop": "_id",
                  onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.pilihFilterFoto($event)))
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_Multiselect, {
                  class: "mx-1",
                  modelValue: _ctx.isSchool,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isSchool) = $event)),
                  placeholder: "Pilih Status Verifikasi",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listValidasi,
                  searchable: true,
                  label: "name",
                  "track-by": "name",
                  "value-prop": "_id",
                  onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.pilihFilterValidasi($event)))
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        (_ctx.listData.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item._id,
                  class: "col-lg-6 fv-row pa-2 ma-2"
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("h3", _hoisted_28, _toDisplayString(item.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("img", {
                          src: item.photoUrl,
                          alt: "",
                          class: "img-fluid"
                        }, null, 8, _hoisted_31)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _hoisted_35,
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("label", _hoisted_37, _toDisplayString(item.nis), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _hoisted_40,
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("label", _hoisted_42, _toDisplayString(item.nisn), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _hoisted_45,
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("label", _hoisted_47, _toDisplayString(item.placeOfBirth) + ", " + _toDisplayString(_ctx.dateOnly(item.dateOfBirth)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _hoisted_49,
                        _hoisted_50,
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("label", _hoisted_52, _toDisplayString(item.grade), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _hoisted_55,
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("label", _hoisted_57, _toDisplayString(item.gradeDetail), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _hoisted_60,
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("label", _hoisted_62, [
                            (item.gender == 'MALE')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_63, " Laki - Laki "))
                              : _createCommentVNode("", true),
                            (item.gender == 'FEMALE')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_64, " Perempuan "))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _hoisted_67,
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("label", _hoisted_69, _toDisplayString(item.address), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _hoisted_71,
                        _hoisted_72,
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.convertTags(item.tags)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _hoisted_76,
                        _hoisted_77,
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("label", _hoisted_79, _toDisplayString(item.note), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _hoisted_81,
                        _hoisted_82,
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("label", _hoisted_84, [
                            _createElementVNode("label", {
                              style: _normalizeStyle({
                        color: _ctx.colorStatus(item.isPrint),
                        fontSize: '12px',
                      })
                            }, _toDisplayString(_ctx.getStatusCetak(item.isPrint)), 5)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _hoisted_86,
                        _hoisted_87,
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("label", _hoisted_89, [
                            _createElementVNode("label", {
                              style: _normalizeStyle({
                        color: _ctx.colorStatus(item.isSchoolValid),
                        fontSize: '12px',
                      })
                            }, _toDisplayString(_ctx.getStatusVerifikasiSekolah(item.isSchoolValid)), 5)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-blue me-3",
                          style: {"background-color":"darkblue","color":"white"},
                          id: "btnVerifikasi",
                          type: "button",
                          onClick: ($event: any) => (_ctx.verifikasiPersonal(_ctx.index, item))
                        }, " Verifikasi ", 8, _hoisted_92),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-primary me-3",
                          id: "btnUpload",
                          type: "button",
                          "data-bs-toggle": "modal",
                          onClick: ($event: any) => (_ctx.uploadPersonal(item)),
                          "data-bs-target": "#kt_modal_upload_personal"
                        }, " Upload Foto ", 8, _hoisted_93),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-warning me-3",
                          id: "btnEdit",
                          type: "button",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_form_add",
                          onClick: ($event: any) => (_ctx.handleEdit(item))
                        }, " Edit ", 8, _hoisted_94),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-danger me-3",
                          id: "btnHapus",
                          type: "button",
                          onClick: ($event: any) => (_ctx.handleDelete(item._id))
                        }, " Hapus ", 8, _hoisted_95)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_99))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_100, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("ul", _hoisted_102, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_103, [
        _createElementVNode("button", {
          class: "btn btn-primary me-3",
          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.verifyModal()))
        }, " Konfirmasi Data ")
      ])
    ], 2),
    _createElementVNode("div", _hoisted_104, [
      _createElementVNode("div", _hoisted_105, [
        _createElementVNode("div", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("div", _hoisted_108, [
              (_ctx.resultImportExcel == false)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_109, " Upload Data Excel "))
                : _createCommentVNode("", true),
              (_ctx.resultImportExcel == true && _ctx.successImport == true)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_110, " Berhasil "))
                : _createCommentVNode("", true),
              (_ctx.resultImportExcel == true && _ctx.successImport == false)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_111, " Gagal "))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_112, [
                _createElementVNode("span", _hoisted_113, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_114, [
              (_ctx.resultImportExcel == false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                    _hoisted_116,
                    (_openBlock(), _createElementBlock("input", {
                      name: "fileexcel",
                      type: "file",
                      id: "fileexcel",
                      class: "form-control form-control-lg mx-5",
                      onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handlefileexcel($event))),
                      key: _ctx.fileInputKey3
                    }, null, 32))
                  ]))
                : _createCommentVNode("", true),
              _hoisted_117,
              (_ctx.resultImportExcel == true && _ctx.successImport == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_118, _hoisted_121))
                : _createCommentVNode("", true),
              (_ctx.resultImportExcel == true && _ctx.successImport == false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_122, _hoisted_125))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_126, [
              (_ctx.resultImportExcel == false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.downloadTemplateExcel()))
                  }, " Download Template "))
                : _createCommentVNode("", true),
              (_ctx.resultImportExcel == false)
                ? (_openBlock(), _createElementBlock("button", _hoisted_127, " Batal "))
                : _createCommentVNode("", true),
              (_ctx.resultImportExcel == false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "btn btn-success",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.importExcelVerifikasi()))
                  }, " Upload "))
                : _createCommentVNode("", true),
              (_ctx.resultImportExcel == true && _ctx.successImport == true)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    type: "button",
                    class: "btn btn-primary",
                    style: {"width":"150px"},
                    "data-bs-dismiss": "modal",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.goToPageHistory()))
                  }, " Oke "))
                : _createCommentVNode("", true),
              (_ctx.resultImportExcel == true && _ctx.successImport == false)
                ? (_openBlock(), _createElementBlock("button", _hoisted_128, " Tutup "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_129, [
      _createElementVNode("div", _hoisted_130, [
        _createElementVNode("div", _hoisted_131, [
          _createElementVNode("div", _hoisted_132, [
            _createElementVNode("div", _hoisted_133, [
              _createElementVNode("h5", _hoisted_134, _toDisplayString(!_ctx.isEdit ? "Tambah User" : "Edit User"), 1),
              _createElementVNode("div", _hoisted_135, [
                _createElementVNode("span", _hoisted_136, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_137, [
              _createElementVNode("div", _hoisted_138, [
                _createElementVNode("div", _hoisted_139, [
                  _hoisted_140,
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("div", _hoisted_142, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "nama",
                        class: "form-control form-control-lg",
                        modelValue: _ctx.formData.name,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.name) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_143,
                  _createElementVNode("div", _hoisted_144, [
                    _createElementVNode("div", _hoisted_145, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "nis",
                        class: "form-control form-control-lg",
                        modelValue: _ctx.formData.nis,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.nis) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_146,
                  _createElementVNode("div", _hoisted_147, [
                    _createElementVNode("div", _hoisted_148, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "nisn",
                        class: "form-control form-control-lg",
                        modelValue: _ctx.formData.nisn,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.nisn) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_149,
                  _createElementVNode("div", _hoisted_150, [
                    _createElementVNode("div", _hoisted_151, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "ttl",
                        class: "form-control form-control-lg",
                        modelValue: _ctx.formData.placeOfBirth,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.placeOfBirth) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_152,
                  _createElementVNode("div", _hoisted_153, [
                    _createElementVNode("div", _hoisted_154, [
                      _createVNode(_component_Field, {
                        type: "date",
                        name: "ttl",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Tanggal Lahir",
                        modelValue: _ctx.formData.dateOfBirth,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.dateOfBirth) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_155,
                  _createElementVNode("div", _hoisted_156, [
                    _createElementVNode("div", _hoisted_157, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "gender",
                        class: "form-control form-control-lg",
                        modelValue: _ctx.formData.gender,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.gender) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_158,
                  _createElementVNode("div", _hoisted_159, [
                    _createElementVNode("div", _hoisted_160, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "kelas",
                        class: "form-control form-control-lg",
                        modelValue: _ctx.formData.grade,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData.grade) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_161, [
                _createElementVNode("div", _hoisted_162, [
                  _hoisted_163,
                  _createElementVNode("div", _hoisted_164, [
                    _createElementVNode("div", _hoisted_165, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "detail_kelas",
                        class: "form-control form-control-lg",
                        modelValue: _ctx.formData.gradeDetail,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData.gradeDetail) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_166,
                  _createElementVNode("div", _hoisted_167, [
                    _createElementVNode("div", _hoisted_168, [
                      _withDirectives(_createElementVNode("textarea", {
                        type: "text",
                        name: "alamat",
                        class: "form-control form-control-lg",
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.address) = $event))
                      }, "\n                    ", 512), [
                        [_vModelText, _ctx.formData.address]
                      ])
                    ])
                  ]),
                  _hoisted_169,
                  _createElementVNode("div", _hoisted_170, [
                    _createElementVNode("div", _hoisted_171, [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.tags,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData.tags) = $event)),
                        class: "form-control",
                        multiple: "",
                        filterable: "",
                        "allow-create": "",
                        "default-first-option": "",
                        placeholder: "Isi Tags",
                        "allow-duplicates": "false"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_172, [
              _hoisted_173,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-success",
                "data-bs-dismiss": "modal",
                onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.addUserByForm()))
              }, " Simpan ")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_174, [
      _createElementVNode("div", _hoisted_175, [
        _createElementVNode("div", _hoisted_176, [
          _createElementVNode("div", _hoisted_177, [
            _createElementVNode("div", _hoisted_178, [
              _hoisted_179,
              _createElementVNode("div", _hoisted_180, [
                _createElementVNode("span", _hoisted_181, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_182, [
              _createElementVNode("div", _hoisted_183, [
                _createElementVNode("div", _hoisted_184, [
                  _createElementVNode("table", _hoisted_185, [
                    _hoisted_186,
                    (_ctx.listUsers.length)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_187, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUsers, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_188, [
                                _createElementVNode("label", _hoisted_189, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    value: { id: item._id, name: item.name },
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.userSelected) = $event)),
                                    onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.log()))
                                  }, null, 40, _hoisted_190), [
                                    [_vModelCheckbox, _ctx.userSelected]
                                  ]),
                                  _hoisted_191
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_192, _toDisplayString(item.name), 1),
                              _createElementVNode("td", _hoisted_193, _toDisplayString(item.nis), 1),
                              _hoisted_194
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_195, _hoisted_197))
                  ])
                ]),
                _createElementVNode("div", _hoisted_198, [
                  _createElementVNode("div", _hoisted_199, [
                    _createElementVNode("div", _hoisted_200, [
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("select", {
                          name: "kt_customers_table_length",
                          class: "form-select form-select-sm form-select-solid",
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.paging2.size) = $event)),
                          placeholder: "Per page",
                          onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.changePageSize2()))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging2.perPageOptions, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, _hoisted_201))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.paging2.size]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_202, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging2.totalElements) + " entries ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_203, [
                    _createElementVNode("ul", _hoisted_204, [
                      _createElementVNode("li", {
                        class: _normalizeClass(["page-item previous", { disabled: _ctx.paging2.page + 1 === 1 }])
                      }, [
                        _createElementVNode("a", {
                          class: "page-link",
                          style: {"cursor":"pointer"},
                          onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.prevPage2 && _ctx.prevPage2(...args)))
                        }, " Previous ")
                      ], 2),
                      _createElementVNode("li", {
                        class: _normalizeClass(["page-item next", {
                        disabled: _ctx.paging2.page + 1 === _ctx.paging2.totalPages,
                      }])
                      }, [
                        _createElementVNode("a", {
                          class: "page-link",
                          style: {"cursor":"pointer"},
                          onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.nextPage2 && _ctx.nextPage2(...args)))
                        }, " Next ")
                      ], 2)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_205, [
              _hoisted_206,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-success",
                "data-bs-dismiss": "modal",
                onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.addUserExisting()))
              }, " Simpan ")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_207, [
      _createElementVNode("div", _hoisted_208, [
        _createElementVNode("div", _hoisted_209, [
          _createElementVNode("div", _hoisted_210, [
            _createElementVNode("div", _hoisted_211, [
              _hoisted_212,
              _createElementVNode("div", _hoisted_213, [
                _createElementVNode("span", _hoisted_214, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_215, [
              _createElementVNode("div", _hoisted_216, [
                _hoisted_217,
                _hoisted_218,
                _createElementVNode("div", _hoisted_219, [
                  _createElementVNode("label", _hoisted_220, _toDisplayString(_ctx.formData.name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_221, [
                _hoisted_222,
                _hoisted_223,
                _createElementVNode("div", _hoisted_224, [
                  _createElementVNode("label", _hoisted_225, _toDisplayString(_ctx.formData.nis), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_226, [
                _hoisted_227,
                _hoisted_228,
                _createElementVNode("div", _hoisted_229, [
                  _createElementVNode("label", _hoisted_230, _toDisplayString(_ctx.formData.nisn), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_231, [
                _hoisted_232,
                _hoisted_233,
                _createElementVNode("div", _hoisted_234, [
                  _createElementVNode("label", _hoisted_235, _toDisplayString(_ctx.formData.gradeDetail), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_236, [
                _hoisted_237,
                (_openBlock(), _createElementBlock("input", {
                  name: "fotosiswapersonal",
                  type: "file",
                  id: "fotosiswapersonal",
                  class: "form-control form-control-lg",
                  onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.handleFotoSiswaPersonal($event))),
                  key: _ctx.fileInputKey3
                }, null, 32))
              ]),
              _createElementVNode("div", _hoisted_238, [
                _createElementVNode("img", {
                  alt: "filepersonal",
                  class: "pl-3",
                  style: {"max-width":"300px"},
                  src: _ctx.imageFotoPersonal
                }, null, 8, _hoisted_239)
              ])
            ]),
            _createElementVNode("div", _hoisted_240, [
              _hoisted_241,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-success",
                "data-bs-dismiss": "modal",
                onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.simpanUploadPersonal()))
              }, " Simpan ")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_242, [
      _createElementVNode("div", _hoisted_243, [
        _createElementVNode("div", _hoisted_244, [
          _createElementVNode("div", _hoisted_245, [
            _createElementVNode("div", _hoisted_246, [
              _hoisted_247,
              _createElementVNode("div", _hoisted_248, [
                _createElementVNode("span", _hoisted_249, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_250, [
              (_ctx.showResultUploadMultiple == false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                    _hoisted_252,
                    (_openBlock(), _createElementBlock("input", {
                      name: "filefotomultiple",
                      type: "file",
                      id: "filefotomultiple",
                      class: "form-control form-control-lg mx-5",
                      multiple: "multiple",
                      onChange: _cache[45] || (_cache[45] = ($event: any) => (_ctx.handlefilefotomultiple($event))),
                      key: _ctx.fileInputKeyMultiple
                    }, null, 32))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showResultUploadMultiple == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_253, _hoisted_255))
                : _createCommentVNode("", true),
              (_ctx.showResultUploadMultiple == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_256, [
                    _hoisted_257,
                    _createElementVNode("div", _hoisted_259, [
                      _createElementVNode("label", _hoisted_260, [
                        _createElementVNode("span", _hoisted_261, _toDisplayString(_ctx.resultTotalMultipleUpload), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showResultUploadMultiple == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                    _hoisted_263,
                    _createElementVNode("div", _hoisted_265, [
                      _createElementVNode("label", _hoisted_266, [
                        _createElementVNode("span", _hoisted_267, _toDisplayString(_ctx.resultSuccessMultipleUpload), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showResultUploadMultiple == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_268, [
                    _hoisted_269,
                    _createElementVNode("div", _hoisted_271, [
                      _createElementVNode("label", _hoisted_272, [
                        _createElementVNode("span", _hoisted_273, _toDisplayString(_ctx.resultFailedMultipleUpload), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_274
            ]),
            _createElementVNode("div", _hoisted_277, [
              (_ctx.showResultUploadMultiple == true)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-warning",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.HistoryFotoFromUpload()))
                  }, " History Upload Foto "))
                : _createCommentVNode("", true),
              (_ctx.showResultUploadMultiple == true)
                ? (_openBlock(), _createElementBlock("button", _hoisted_278, " OK "))
                : _createCommentVNode("", true),
              (_ctx.showResultUploadMultiple == false)
                ? (_openBlock(), _createElementBlock("button", _hoisted_279, " Batal "))
                : _createCommentVNode("", true),
              (_ctx.showResultUploadMultiple == false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    type: "button",
                    class: "btn btn-success",
                    onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.simpanFotoMultiple()))
                  }, " Simpan "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_280, [
      _createElementVNode("div", _hoisted_281, [
        _createElementVNode("div", _hoisted_282, [
          _createElementVNode("div", _hoisted_283, [
            _createElementVNode("div", _hoisted_284, [
              _hoisted_285,
              _createElementVNode("div", _hoisted_286, [
                _createElementVNode("span", _hoisted_287, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _hoisted_288,
            _createElementVNode("div", _hoisted_289, [
              _hoisted_290,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                "data-bs-dismiss": "modal",
                onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.confirmStep()))
              }, " Ok ")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_291, [
      _createElementVNode("div", _hoisted_292, [
        _createElementVNode("div", _hoisted_293, [
          _createElementVNode("div", _hoisted_294, [
            _createElementVNode("div", _hoisted_295, [
              _hoisted_296,
              _createElementVNode("div", _hoisted_297, [
                _createElementVNode("span", _hoisted_298, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_299, [
              _hoisted_300,
              _createElementVNode("div", _hoisted_301, [
                _createElementVNode("div", _hoisted_302, [
                  _createElementVNode("label", _hoisted_303, [
                    _hoisted_304,
                    _createElementVNode("span", _hoisted_305, _toDisplayString(_ctx.summary.photoUrl), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_306, [
                  _createElementVNode("label", _hoisted_307, [
                    _hoisted_308,
                    _createElementVNode("span", _hoisted_309, _toDisplayString(_ctx.summary.nothingphotoUrl), 1)
                  ])
                ])
              ]),
              _hoisted_310
            ]),
            _createElementVNode("div", _hoisted_311, [
              _hoisted_312,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                "data-bs-dismiss": "modal",
                onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.simpanVerifikasiMultiple()))
              }, " Ok ")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}